import request from '@/utils/request'

export function login(data) {
	return request({
		url: '/api/user.Login/password',
		method: 'post',
		data
	})
}

export function getData(data) {
	return request({
		url: '/api/user.User/getData',
		method: 'get',
		data
	})
}



// WEBPACK FOOTER //
// ./src/apis/user.js